import React from "react";

const LockIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.076"
      height="24.886"
      viewBox="0 0 19.076 24.886"
      fill={fill}
    >
      <path
        id="db91"
        d="M230.269,173.848H228.5v-4.333a6.336,6.336,0,1,0-12.658,0v4.333h-1.768a1.441,1.441,0,0,0-1.441,1.441v11.038a1.441,1.441,0,0,0,1.441,1.441h16.194a1.441,1.441,0,0,0,1.441-1.441V175.289a1.441,1.441,0,0,0-1.441-1.441Zm-7.428,7.232v3.012H221.5V181.08a1.842,1.842,0,1,1,1.337,0Zm3.878-7.232h-9.092v-4.333a4.556,4.556,0,1,1,9.093,0Z"
        transform="translate(-212.634 -162.883)"
      />
    </svg>
  );
};

export default LockIcon;
